import { SingleVirtual } from 'modules/profile/services/singleVirtual';

const singleVirtualService = new SingleVirtual();

export { singleVirtualService };
export * from './virtual';
export * from './classic';
